import type { ChannelReactionsMode, ConversationDto, MessageDto, ReactionDto } from '@dijitalapp/shared';

/** How many chose an emoji: counted in channels (nobody's id), the people in chats. */
export const reactionCount = (r: ReactionDto) => r.count ?? r.userIds.length;

/** A channel post's reactions as WhatsApp shows them: the most chosen first, and how many in all. */
export function reactionSummary(reactions: ReactionDto[]): { sorted: ReactionDto[]; total: number } {
  const sorted = reactions.filter((r) => reactionCount(r) > 0).sort((a, b) => reactionCount(b) - reactionCount(a));
  return { sorted, total: sorted.reduce((n, r) => n + reactionCount(r), 0) };
}

/** A channel's reaction setting (every emoji when the server did not say). */
export const channelReactionsMode = (c: ConversationDto | null | undefined): ChannelReactionsMode => c?.group?.reactionsMode ?? 'all';

/** A channel post's summary counts (`count` on each emoji) rather than naming people. */
export const countedReactions = (m: MessageDto) => m.reactions.some((r) => r.count !== undefined);

/** One person's change to a channel post's counts (the app shows it at once; the server's answer follows). */
export function adjustCounts(reactions: ReactionDto[], from: string | null | undefined, to: string | null): ReactionDto[] {
  if ((from ?? null) === to) return reactions;
  const out = reactions.map((r) => ({ ...r, userIds: [], count: reactionCount(r) - (r.emoji === from ? 1 : 0) + (r.emoji === to ? 1 : 0) }));
  if (to && !out.some((r) => r.emoji === to)) out.push({ emoji: to, userIds: [], count: 1 });
  return out.filter((r) => r.count > 0);
}
